document.addEventListener("DOMContentLoaded", function () {
  const accordionTitle = document.querySelectorAll(".accordion__title");
  const productDescription = document.querySelector(".product__description");
  const productSpecsCol = Array.from(document.querySelectorAll('.product-specs-col'));
  const vtgoProductSpect = document.querySelector(".vtgo-product-spect");
  const ventorLink = document.querySelectorAll('.product__form__link');
  const vtgoImportantRoll = document.querySelector('.vtgo-important-roll');
  const vtgoImportantRollRockered = document.querySelector('.vtgo-important-roll-rockered');
  const formLabelStrong = document.querySelectorAll('.form__label strong');
  const couponCodeCart = document.querySelector('#coupon_code_cart');
  const productMedia = document.querySelector('.product__media');
  const productMediaContainer = document.querySelector('.product__media_container');

  if (productMedia === null && productMediaContainer !== null) productMediaContainer.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0863/6170/2732/files/no-image.svg?v=1738783370" alt="No Image"/>';

  if (document.documentElement.lang === "bg") {
    if (vtgoImportantRoll !== null) vtgoImportantRoll.innerText = 'Спирачката е несъвместима с рокерирани и Triskate 3x110 шини!';
    if (vtgoImportantRollRockered !== null) vtgoImportantRollRockered.innerText = 'Спирачката е несъвместима с рокерирани шини!';
    if (couponCodeCart !== null ) couponCodeCart.placeholder = 'Код за отстъпка';
    if (formLabelStrong.length > 0) {
      formLabelStrong.forEach(label => {
        if (label.innerText === 'Color:') label.innerText = 'Цвят:';
        if (label.innerText === 'Size:') label.innerText = 'Размер:';
        if (label.innerText === 'Shoe size:') label.innerText = 'Размер:';
        if (label.innerText === 'Length of laces:') label.innerText = 'Дължина:';
      })
    }
  }

  if (document.documentElement.lang === "en") {
    if (formLabelStrong.length > 0) {
      formLabelStrong.forEach(label => {
        if (label.innerText === 'Shoe size:') label.innerText = 'Size:';
        if (label.innerText === 'Length of laces:') label.innerText = 'Length:';
      })
    }
  }

  if (productDescription === null) {
    accordionTitle.forEach((title) => {
      if (title.innerText === "Description" || title.innerText === "Описание") {
        const parentAccordion = title.closest(".product__accordion");
        if (parentAccordion) parentAccordion.remove();
      }
    });
  }

  if (document.querySelector('.product-specs-col') && productSpecsCol.length === 0) {
    vtgoProductSpect.remove();
  } else {
    productSpecsCol.forEach((row, index) => {
      if (index % 2 === 0) row.style.background = '#d8dbe254'
    } )
  }

  if (productSpecsCol.length === 0 && vtgoProductSpect !== null) vtgoProductSpect.remove();

  const URL = 'https://cdn.shopify.com/s/files/1/0863/6170/2732/files/';

  if (ventorLink && ventorLink.innerHTML !== null) {
    ventorLink.forEach(vendor => {
      let vendorLogo = vendor.innerText.toLowerCase();

      switch (vendorLogo) {
            case 'all is possible':
                vendorLogo = 'all';
                break;
            case 'vertigo skates':
                vendorLogo = 'vtgo';
                break;
            case 'ground control':
                vendorLogo = 'gc';
                break;
            case 'red eye':
                vendorLogo = 'red';
                break;
            case 'fr':
                vendorLogo = 'fr-skates';
                break;
        }
      vendor.innerHTML = `<img src=\"${URL}${vendorLogo}.svg\" width=\"16px\" height=\"16px\" alt=\"${vendor.innerText}\" />`;
    });
  }

});
